module.exports = __webpack_public_path__ + "static/media/spacehologram_2.2895e453.jpg";